@if (appUrl$ | async) {
  <a mat-stroked-button class="launch-app-button-desktop" href="{{ appUrl$ | async }}" target="_blank">
    {{ 'PRODUCTS.LAUNCH' | translate }}
    <mat-icon iconPositionEnd>open_in_new</mat-icon>
  </a>
  <a mat-icon-button class="launch-app-button-mobile" href="{{ appUrl$ | async }}" target="_blank">
    <mat-icon size="small" class="launch-app-button-icon">open_in_new</mat-icon>
  </a>
}
